import React from 'react';
import Select from 'react-select';
import ReactQuill from 'react-quill';

export function errorField({ meta: {touched, error}}) {
    return (
        <div className={`new-field-box${touched && ( error && " show-error")}`}>
            { <label>{ touched && ( error && <span>{error}</span> ) }</label> }
        </div>
    );
}

export const textField = ({input, label, placeholder, initialValue, meta: {touched, error, warning}}) => {
    return (
        <div className={`new-field-box${touched && ( error && " show-error")}`}>
	        { label && <label>{ label }
	        { touched &&
            ( error && <span>{error}</span> )
	        }
	        </label> }
            <input { ...input } type="text" placeholder={ placeholder || null }
                   value={ initialValue ? initialValue : input.value } />
        </div>
    );
};

export const selectField = ({input, clearable, initialValue, label, placeholder, options, multi, meta: {touched, error, warning}}) => {
    return (
        <div className={`new-field-box${touched && ( error && " show-error")}`}>
            { label && <label>{ label } { touched && ( error && <span>{error}</span> ) }</label> }

            <Select
                value={ input.value || "" }
                placeholder={ placeholder || 'Select...' }
                isMulti={multi || false}
                onChange={ input.onChange }
                options={ options }
                clearable={ clearable ? clearable : false }
                className="select"
                classNamePrefix="select"
            />
        </div>
    );
};


export const selectFieldTwo = ({input, name, clearable, initialValue, label, placeholder, options, multi, meta: {touched, error, warning}}) => {
    return (
        <div className={`new-field-box${touched && ( error && " show-error")}`}>
	        { label && <label>{ touched && ( error && <span>{error}</span> ) }</label> }
            <Select
                autoFocus
                value={ input.value || "" }
                onChange={ input.onChange }
                // onBlur={ () => input.onBlur( input.value ) }
                options={ options }
                placeholder={ placeholder }
                simpleValue
            />
        </div>
    );
};

export const selectFieldThree = ({input, clearable, initialValue, label, placeholder, options, multi, validate, disabled, meta: {touched, error, warning}}) => {
	return (
        <div className={`new-field-box${touched && ( error && " show-error")}`}>
	        { label && <label>{ label } { touched && ( error && <span>{error}</span> ) }</label> }
            <Select
                // className={ touched ? !error ? " approved-field" : " error-field" : "" }
                className={ touched ? (!error ? "" : " error-field") : "" }
                value={ initialValue ? initialValue : input.value }
                placeholder={ placeholder  ||  'Select...' }
                multi={ multi || false }
                onChange={ input.onChange }
                options={ options }
                //validate={ validate }
                clearable={ clearable ? clearable : false }
                onBlur={ () => input.onBlur( input.value ) }
                disabled={!!disabled}
            />
        </div>
	);
};


export const textAreaField = ({input, label, placeholder, style, meta: {touched, error, warning}}) => {
    return (
        <div>
            { label && <label>{ label }</label>}
            <textarea className="form-control" { ...input }
                      placeholder={ placeholder || null }
                      style={ style || null }
            />
            { touched &&
            (
                ( error && <span className="error">{ error }</span> )
                ||
                ( warning && <span className="warning">{ warning }</span> )
            )
            }
        </div>
    );
};

export const checkboxField = ({input, label, placeholder, checked, initialValue, onClick, meta: {touched, error, warning}}) => {
    return (
        <div className="form-checkbox">
            {/*{ label && <label>{ label }</label>}*/}
            <input value={ initialValue ? initialValue : input.value }  { ...input } type="checkbox" onClick={ onClick }

                   placeholder={ placeholder || null }
                   checked={checked}
            />
            { touched &&
            (
                ( error && <span className="error">{ error }</span> )
                ||
                ( warning && <span className="warning">{ warning }</span> )
            )
            }
            <label className="checkbox-label">{ label }</label>
        </div>
    )
};


export const quill = ({input, label, placeholder, style }) => {
    return (
        <div>
            { label && <label>{ label }</label> }
            <ReactQuill theme="snow"
                        { ...input }
                        placeholder={ placeholder && `${ placeholder } NB ensure you write http():// before any hyperlinks eg https://www.google.com.` }
                        style={ style || null }
                        onBlur={ () => input.onBlur }
            />
        </div>
    );
};

export function validate(field) {

    return [(value) => value ? undefined : `${ field } is required.`];
  //  return [(value) => console.log( 'LOG: ', value )];
}







// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/formFieldHelpers.js